import axios from "axios";

export const BASE_URL = "https://api.cheonhojeil.org"
export const apiClient = axios.create({
    baseURL: `${BASE_URL}/api/v1`, // 기본 API URL
    headers: {
        'Content-Type': 'application/json'
    }
});